<!--
 * @Descripttion: 注册页面组件(手机号+短信验证码,自动注册)
 * @Author: cmall
 * @Date: 2026-08-13
-->
<template>
  <div class="register">
    <div>
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
          <span>Register</span>
        </div>
        <div class="item">
          <el-form :model="form" status-icon :rules="rules" ref="form">
            <el-form-item prop="phone">
              <el-input
                v-model="form.phone"
                placeholder="Phone Number"
              ></el-input>
            </el-form-item>
            <el-form-item prop="captcha_value">
              <div class="math-captcha">
                <span
                  class="math-captcha-text"
                  title="Click to refresh"
                  @click="refreshCaptcha"
                  >{{ captcha.expression || 'Loading...' }}</span
                >
                <el-input
                  v-model="form.captcha_value"
                  placeholder="Answer"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item prop="code">
              <el-input
                v-model="form.code"
                maxlength="6"
                placeholder="SMS Verification Code"
              >
                <template slot="append">
                  <a href="javascript:;" class="sms-send" @click="sendCode">{{
                    countdown > 0 ? countdown + 's' : 'Send Code'
                  }}</a>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <div style="margin-top:15px">
            <a
              href="javascript:;"
              class="btn-gradient desert block"
              @click="register('form')"
              >Register</a
            >
          </div>
          <el-link
            type="primary"
            href="/#/login"
            style="float:right;margin-bottom:20px;"
            >Already have an account? Log in directly></el-link
          >
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import * as userAPI from '@/api/users'
export default {
  name: 'Register',
  data() {
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your phone number'))
      } else if (value.length < 6 || value.length > 15) {
        callback(new Error('Please enter a valid phone number'))
      }
      callback()
    }
    var validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the verification code'))
      } else if (value.length !== 6) {
        callback(new Error('The verification code should be 6 digits'))
      }
      callback()
    }
    var validateCaptcha = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the math captcha answer'))
      }
      callback()
    }
    return {
      captcha: {
        captcha_id: '',
        expression: ''
      },
      form: {
        phone: '',
        code: '',
        captcha_value: ''
      },
      countdown: 0,
      rules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        code: [{ validator: validateCode, trigger: 'blur' }],
        captcha_value: [{ validator: validateCaptcha, trigger: 'blur' }]
      }
    }
  },
  methods: {
    ...mapActions(['setUser']),
    // 刷新算式验证码
    refreshCaptcha() {
      userAPI
        .getMathCaptcha()
        .then(res => {
          if (res.status === 200) {
            this.captcha.captcha_id = res.data.captcha_id
            this.captcha.expression = res.data.expression
          }
        })
        .catch(() => {
          this.captcha.expression = 'Refresh failed'
        })
    },
    // 发送短信验证码(需先通过算式验证码)
    sendCode() {
      if (this.countdown > 0) {
        return
      }
      if (this.form.phone === '') {
        this.notifyError('Please enter your phone number')
        return
      }
      if (this.form.captcha_value === '') {
        this.notifyError('Please enter the math captcha answer')
        return
      }
      userAPI
        .sendSMSCode({
          phone: this.form.phone,
          captcha_id: this.captcha.captcha_id,
          captcha_value: this.form.captcha_value
        })
        .then(res => {
          if (res.status === 200) {
            // 发送成功后才启动倒计时
            this.startCountdown()
            this.notifySucceed('SMS code sent, please check your phone')
          } else {
            this.notifyError('Failed to send code', res.msg)
          }
          // 算式验证码一次性,无论成败都清空并刷新
          this.form.captcha_value = ''
          this.refreshCaptcha()
        })
        .catch(error => {
          this.form.captcha_value = ''
          this.refreshCaptcha()
          this.notifyError('Failed to send code', error)
        })
    },
    // 60秒发送倒计时
    startCountdown() {
      var self = this
      self.countdown = 60
      var clock = window.setInterval(() => {
        self.countdown--
        if (self.countdown <= 0) {
          window.clearInterval(clock)
          self.countdown = 0
        }
      }, 1000)
    },
    // 注册(验证码校验通过即自动注册并登录)
    register(formName) {
      var self = this
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return
        }
        userAPI
          .smsLogin({
            phone: self.form.phone,
            code: self.form.code
          })
          .then(res => {
            if (res.status === 200) {
              // 登录信息存到本地
              let user = JSON.stringify(res.data.user)
              localStorage.setItem('user', user)
              localStorage.setItem('token', res.data.token)
              // 登录信息存到vuex(必须,header登录态依赖vuex)
              self.setUser(res.data.user)
              self.notifySucceed('Registered and logged in successfully')
              self.$router.push({
                name: 'Home'
              })
            } else {
              self.notifyError('Registration failed', res.msg)
            }
          })
          .catch(error => {
            self.notifyError('Registration failed', error)
          })
      })
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  components: {}
}
</script>

<style scoped>
@import '../assets/css/button.css';
.text {
  font-size: 14px;
}

.item {
  margin: 0 auto;
  width: 300px;
}

.clearfix {
  font-size: 20px;
}

.box-card {
  margin: 0 auto;
  text-align: center;
  width: 400px;
  margin-top: 100px;
  margin-bottom: 200px;
  border-radius: 10px;
}
/*算式验证码*/
.math-captcha {
  display: flex;
  width: 100%;
}
.math-captcha-text {
  flex: 0 0 90px;
  height: 40px;
  line-height: 40px;
  background-color: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-right: none;
  border-radius: 4px 0 0 4px;
  color: #409eff;
  font-weight: bold;
  cursor: pointer;
  user-select: none;
}
.sms-send {
  cursor: pointer;
  color: #409eff;
}
</style>
